export default "__VITE_ASSET__BSXK$XT$__"